import { render, staticRenderFns } from "./SftpDetailsPopUp.vue?vue&type=template&id=1af3f69e&scoped=true&"
import script from "./SftpDetailsPopUp.vue?vue&type=script&lang=js&"
export * from "./SftpDetailsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SftpDetailsPopUp.vue?vue&type=style&index=0&id=1af3f69e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3f69e",
  null
  
)

export default component.exports